export default __webpack_public_path__ + "static/media/footerBr.1119ecf2.png";